import axios from 'axios';

import { Resolve } from './';
import config from './config';

const url = process.env.VUE_APP_SERVER_PATH;

export const getClientLicencesUsage = (client_account_id: number) => new Promise((resolve: Resolve<any[]>, reject) => {
  axios
    .get(`${url}/v2/client-account-licenses?client_account_id=${client_account_id}`, config())
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err);
    });
});